export function StepOneParentValidation(data) {
  const errors = {};

  const fullNameRegex = /^[\u0600-\u06FF\s]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex = /^[A-Za-z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/;
  const phoneRegex = /^(?:\+966|0)([5,6,9])\d{8}$/;

  if (!data.parentName) {
    errors.parentName = "حقل اسم ولي الأمر مطلوب";
  } else if (!fullNameRegex.test(data.parentName)) {
    errors.parentName = "ادخل اسم صحيح";
  }

  if (!data.email) {
    errors.email = " حقل البريد الإلكتروني مطلوب";
  } else if (!emailRegex.test(data.email)) {
    errors.email = "ادخل صيغة بريد إلكتروني صحيحة";
  }

  if (!data.password) {
    errors.password = " حقل  كلمة المرور مطلوب";
  } else if (!passwordRegex.test(data.password)) {
    errors.password = "يجب أن تحتوي كلمة المرور على أكثر من 8 أحرف";
  }

  if (!data.phone) {
    errors.phone = " حقل رقم الهاتف مطلوب";
  } else if (!phoneRegex.test(data.phone)) {
    errors.phone = "يجب أن يحتوي رقم الهاتف على 10 أرقام ";
  }

  return errors;
}

export function StepTwoParentValidation(data) {
  const errors = {};

  const fullNameRegex = /^[\u0600-\u06FF\s]+$/;

  if (!data.childName) {
    errors.childName = "حقل اسم الطفل  مطلوب ";
  } else if (!fullNameRegex.test(data.childName)) {
    errors.childName = "ادخل اسم صحيح";
  }

  if (!data.birthday) {
    errors.birthday = " حقل تاريخ الميلاد مطلوب ";
  }
  if (!data.childCondition) {
    errors.childCondition = "حقل حالة الطفل مطلوب";
  }
  if (!data?.childReport?.length) {
    errors.childReport = "حقل تقرير بحالة الطفل مطلوب";
  }

  return errors;
}

export function StepOneSpecialistValidation(data) {
  const errors = {};

  const fullNameRegex = /^[\u0600-\u06FF\s]+$/;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const passwordRegex = /^[A-Za-z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/;

  const phoneRegex = /^(?:\+966|0)([5,6,9])\d{8}$/;

  if (!data.fullName) {
    errors.fullName = "حقل الاسم الكامل  مطلوب";
  } else if (!fullNameRegex.test(data.fullName)) {
    errors.fullName = "ادخل اسم صحيح";
  }

  if (!data.email) {
    errors.email = " حقل البريد الإلكتروني مطلوب";
  } else if (!emailRegex.test(data.email)) {
    errors.email = "ادخل صيغة بريد إلكتروني صحيحة";
  }

  if (!data.password) {
    errors.password = " حقل  كلمة المرور مطلوب";
  } else if (!passwordRegex.test(data.password)) {
    errors.password = "يجب أن تحتوي كلمة المرور على أكثر من 8 أحرف";
  }

  if (!data.confirmPassword) {
    errors.confirmPassword = "تأكد من تطابق كلمة السر";
  } else if (data.confirmPassword !== data.password) {
    errors.confirmPassword = "كلمتا السر غير متطابقتان";
  }

  if (!data.phone) {
    errors.phone = " حقل رقم الهاتف مطلوب";
  } else if (!phoneRegex.test(data.phone)) {
    errors.phone = "يجب أن يحتوي رقم الهاتف على 10 أرقام ";
  }

  return errors;
}

export function StepTwoSpecialistValidation(data) {
  const errors = {};

  if (!data.brief) {
    errors.brief = "حقل نبذة قصيرة  مطلوب";
  }
  if (!data.city) {
    errors.city = "حقل المدينة  مطلوب";
  }
  if (!data.district) {
    errors.district = "حقل الحي  مطلوب";
  }
  if (!data.degree) {
    errors.degree = "حقل الدرجة العلمية  مطلوب";
  }
  if (!data.specialization) {
    errors.specialization = "حقل التخصص  مطلوب";
  }
  if (!data.yearsOfExperience) {
    errors.yearsOfExperience = "حقل سنوات الخبرة  مطلوب";
  }

  return errors;
}
